import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/catch'
import { catchError, map, startWith } from 'rxjs/operators';
import { ValidateDate } from '../date-validator';
import { ListObject } from '../models/dplist.model';
import { Observable, Subject } from 'rxjs';
import { ArrayData } from '../dpListNew/dplistNew.component';

export interface State{
  name:string;
}

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss']
})
export class PlaygroundComponent implements OnInit {

  // inWhichCity = new FormControl();
  // filteredCities: Observable<State[]>;
  isDisabled = true;
  defaultValue1: ListObject = { id: 0, name: "בחר" };
  educations: ListObject[] = [
    { id: 0, name: "בחר" },
    { id: 1, name: 'יסודי' },
    { id: 2, name: 'אוניברסיטה' },
    { id: 3, name: 'תיכונית' },
    { id: 4, name: 'על תיכונית' }
  ];

  

  userDetails: FormGroup;
  formGroup: FormGroup;
  minBirthDate = { year: (new Date().getFullYear()) - 100, month: 1, day: 1 }; //from -100 years
  maxBirthDate = { year: (new Date().getFullYear()) - 15, month: 12, day: 31 };  //to 15 years old
  constructor(private fb: FormBuilder, private httpClient: HttpClient) {

 

		// this.filteredCities = this.inWhichCity.valueChanges
		// 	.pipe(
		// 		startWith(''),
		// 		map(city => city ? this.filterCities(city) : this.state.slice())
		// 	);
   }

  defaultValue2: ListObject = { id: 0, name: "בחר" };
  maritalStatus: ListObject[] = [
    { id: 0, name: "בחר" },
    { id: 1, name: 'רווק' },
    { id: 2, name: 'נשוי' },
    { id: 3, name: 'גרוש' },
    { id: 4, name: 'אלמן' }
  ];

  maritalStatusNew: Array<string> = ['רווק', 'נשוי', 'גרוש', 'אלמן'];
  defaultValueNew = 'בחר';

  educationNew: Array<string> = ['יסודי', 'אוניברסיטה', 'תיכונית', 'על תיכונית'];
  educationNewObs: Observable<ArrayData[]> = new Observable<ArrayData[]>();

  dplistNewValue = 2;


  state: State[] = [
    {
      name: 'Arkans',
    },
    {
      name: 'Calfifornia',
    },
    {
      name: 'Florida',
    },
    {
      name: 'x',
    },
    {
      name: 'y',
    },
    {
      name: 'z',
    },
    {
      name: 'q',
    }
  ]

	// filterCities(name: any) {
	// 	return this.state.filter(city =>
	// 		city.name.toLowerCase().indexOf(name.toLowerCase()) === 0);


	// }


  ngOnInit() {
    this.formGroup = new FormGroup({
      education: new FormControl(this.defaultValue1),
      maritalStatus: new FormControl(this.defaultValue2)
    });
    this.userDetails = this.fb.group({
      birthDate: [{ name: "birthDate", validators: [Validators.required, ValidateDate], type: "Date" }],
      maritalStatusNew: [{ name: "maritalStatusNew" }],
      educationNew: [{ name: "educationNew" }],
      inWhichCity:['',  Validators.required]
    })

    this.userDetails.controls['educationNew'].setValue('יסודי');
    this.userDetails.controls['maritalStatusNew'].setValue('');

    this.educationNewObs = new Observable(subscriber => {
      setTimeout(() => {
        const arr: Array<ArrayData> = [];

        this.educationNew.forEach(el => {
          arr.push({
            name: el,
            mtext: el
          });
        })
        
        subscriber.next(arr);
        subscriber.complete();
        console.log('setTimeout...')
  
      }, 500)
    })
  }

  sendRequest2() {
    const url = 'http://localhost/SCTofesMashkantaWebAPI/api/TofesMashkanta/CreateOpportunityForCustomer';
    this.httpClient.post(url, {
      OpportunityNumber: '',
      ID15: '1700',
      CreateSource: 'DIG',
      MatArrivedCode: '81',
      MatArrivedScendId: '23',
      MatSiteLocId: '1',
      FormStage: '4',
      Privacy: '',
      RequiredDate: '29/03/2022',
      ConsultantId: '1159',
      ConsultFirmId: '1001',
      PurposeOfLoan: '',
      AmountRequested: '',
      AmountProperty: '',
      CityOfTheProperty: '',
      SignedContract: '',
      FirstResponseChannel: '01',
      Loans: [{
        CustomerIdType: '1',
        CustomerId: '999436587',
        PrimaryCustomer: 'Y',
        Email: 'TEST123@WALLA.COM',
        PrefixPhone: '050',
        PhoneNumber: '6408361'
      }]
    })/*.catch((err: HttpErrorResponse) => {
      console.log('send result error', err);
      return of([]);
    })*/.subscribe(res => {
      console.log('send result', res);
    }, err => {
      console.log('send result error 2', err);
    });
  }

  sendRequest3() {
    const url = 'http://localhost/SCTofesMashkantaWebAPI/api/TofesMashkanta/GetConsultantDetails';
    this.httpClient.post(url, {
      SystemCode: '3',
      ConsultantIdnt: '36412138'
    })/*.catch((err: HttpErrorResponse) => {
      console.log('send result error', err);
      return of([]);
    })*/.subscribe(res => {
      console.log('send result', res);
    }, err => {
      console.log('send result error 2', err);
    });
  }

  // getSysTables() {
  //   const url = 'http://localhost/SCTofesMashkantaWebAPI/api/TofesMashkanta/GetSysTables';
  //   this.httpClient.post(url, [1499]).subscribe(res => {
  //     console.log('send result', res);
  //   }, err => {
  //     console.log('send result error 2', err);
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/app/playground/playground.component.ts